import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type {
  BreederRelatedLinksGetBreedsQuery,
  BreederRelatedLinksGetBreedsQueryVariables,
} from '@gql/graphql';
import { useMemo } from 'react';

export const BREEDER_RELATED_LINK_GET_BREEDS = graphql(`
  query BreederRelatedLinksGetBreeds(
    $take: Int
    $where: DogBreedWhereInput
    $translationsWhere: DogBreedTranslationWhereInput
  ) {
    findManyDogBreed(where: $where, take: $take, randomOrder: true) {
      id
      translations(where: $translationsWhere) {
        id
        url
        name
      }
    }
  }
`);

export const useGetBreeds = () => {
  const { language } = useRouter();

  const variables = useMemo((): BreederRelatedLinksGetBreedsQueryVariables => {
    return {
      take: 10,
      translationsWhere: { language: { equals: language } },
      where: {
        AND: [
          {
            translations: {
              every: {
                AND: [
                  { description: { not: { equals: '' } } },
                  { description: { not: { equals: null } } },
                ],
              },
            },
          },
          { isSubBreed: { equals: false } },
        ],
      },
    };
  }, [language]);

  const { data, error, loading } = useQuery<
    BreederRelatedLinksGetBreedsQuery,
    BreederRelatedLinksGetBreedsQueryVariables
  >(BREEDER_RELATED_LINK_GET_BREEDS, {
    variables,
    ssr: false,
  });

  return {
    breeds: data?.findManyDogBreed ?? [],
    breedsError: error,
    breedsLoading: loading,
  };
};
